import { FC, ReactNode } from "react";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";

type Props = {
  /** Mensagem de status (ex.: "Processando pagamento...") */
  message: string;
  children?: ReactNode;
};

/** Tela full-viewport de carregamento com a marca — usada em fluxos transitórios
 *  fora do dashboard (retorno de pagamento, redirect de auth). Respeita o tema. */
const FullScreenLoader: FC<Props> = ({ message, children }) => {
  const theme = useTheme();
  const logo = theme.palette.mode === "dark" ? "/imgs/newLogoWhite.svg" : "/imgs/newLogo.svg";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 3,
        p: 3,
        backgroundColor: "background.default",
      }}
    >
      <Box component="img" src={logo} alt="ProAtivos" sx={{ width: "100%", maxWidth: 220 }} />
      <CircularProgress color="primary" size={32} />
      <Typography sx={{ fontFamily: theme.typography.fontFamilyDisplay, fontSize: 20, color: "text.primary", textAlign: "center" }}>
        {message}
      </Typography>
      {children}
    </Box>
  );
};

export default FullScreenLoader;
